import { useQuery } from '@tanstack/react-query';

import { useListagemContext } from 'context/ListagemContext';
import { useRequestListagem } from 'hooks/useRequestListagem';

export function useQueryPermissoes() {
    const requestListagem = useRequestListagem();
    const { page, filter, sort, limit } = useListagemContext();

    return useQuery({
        queryKey: ['permissoes', page, filter, sort, limit],
        queryFn: () =>
            requestListagem({
                url: '/gestao/grupousuario',
                filter,
                limit,
                page,
                sort: sort.length ? sort : [{ property: 'idGrupoUsuario', direction: 'DESC' }],
                columns: 'idGrupoUsuario,dsGrupoUsuario,dsObservacao,fgPadraoFranqueado,dsGrupoEconomico,fgAtivo',
                nested: true,
            }).then((res) => res.data),
    });
}
